import React from 'react'
import PriceList from './PriceList'

function Price() {
  return (
    <div className='pt-10'>
      <PriceList />
    </div>
  )
}

export default Price
